module.exports = __webpack_public_path__ + "static/img/zhizhen.5a8d3e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diagnosis/zhizhen.png
// module id = Te7D
// module chunks = 3